// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gsfBtn{color:#fff!important;background:#399342;border-radius:5px;padding-top:10px;padding-bottom:10px;padding-left:17px;padding-right:16px}.gsfBtn:hover{background:#5ab163}", ""]);
// Exports
module.exports = exports;
